package app.bloomey.web.components.widgets

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.style.ComponentStyle
import com.varabyte.kobweb.silk.components.style.toModifier
import io.data2viz.charts.chart.chart
import io.data2viz.charts.chart.discrete
import io.data2viz.charts.chart.mark.area
import io.data2viz.charts.chart.mark.dot
import io.data2viz.charts.chart.quantitative
import io.data2viz.charts.viz.newVizContainer
import io.data2viz.geom.Size
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.dom.Div


val ChartContainerStyle by ComponentStyle {
    base {
        Modifier
            .maxWidth(100.percent)
            .maxHeight(100.percent)
            .minHeight(100.percent)
            .minWidth(100.percent)
    }
    cssRule(" canvas") {
        Modifier
            .maxWidth(100.percent)
            .maxHeight(100.percent)
            .minHeight(100.percent)
            .minWidth(100.percent)
    }
}

@Composable
fun <T> ChartContainer(
    data: List<T> = emptyList(),
    quantitative: (T) -> Double,
    formatter: (T) -> String,
) {
    Div(attrs = Modifier
        .fillMaxSize()
        .then(ChartContainerStyle.toModifier())
        .styleModifier {
            property("min-height", "100%")
        }
        .toAttrs {
        }) {
        DisposableEffect(this) {
            scopeElement.newVizContainer().apply {
                size = Size(scopeElement.clientWidth.toDouble(), height = scopeElement.clientHeight.toDouble())
                chart(data) {
                    val peeks = quantitative({ quantitative(domain) }) {
                        this.formatter = {
                            "${this?.toInt()}"
                        }
                    }
                    val x = discrete({ domain }) {
                        this.formatter = {
                            formatter(this)
                        }
                    }
                    dot(x, peeks)
                    area(x, peeks)
                }
            }
            onDispose {
                scopeElement.remove()
            }
        }
    }
}